"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  * {\n    font-variant: normal !important;\n    font-feature-settings: normal !important;\n  }\n\n  // Increase the size of icons in icon-only circular buttons.\n  .ant-btn-circle.ant-btn-icon-only {\n    padding: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    > * {\n      font-size: 24px;\n    }\n    svg {\n      display: block;\n      stroke-width: 1.25;\n    }\n  }\n\n  // Border radius for modals.\n  .ant-modal-content {\n    border-radius: ", " !important;\n    .ant-modal-header {\n      border-radius: ", " ", " 0 0 !important;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AntOverrides = void 0;

var styled_components_1 = require("styled-components");

exports.AntOverrides = (0, styled_components_1.createGlobalStyle)(_templateObject(), function (props) {
  return props.theme['@border-radius-large'];
}, function (props) {
  return props.theme['@border-radius-large'];
}, function (props) {
  return props.theme['@border-radius-large'];
});